import oc from 'octobercms';

export default new class Uploader {
  constructor() {
    this.dropzoneClass = 'dropzone'
    this.init();
  }

  init() {
    const fileInput = document.querySelector('._file-input');
    const sessionKeyInput = document.querySelector('[name="_session_key"]');

    const sessionKey = sessionKeyInput.value;

    fileInput.addEventListener('change', () => {
      const fileLabel = fileInput.nextElementSibling;
      if (fileInput.files.length > 0) {
        fileLabel.setAttribute("data-file", fileInput.files[0].name);
      } else {
        fileLabel.removeAttribute("data-file");
      }
      var fReader = new FileReader();
      const type = fileInput.files[0].type;

      fReader.readAsDataURL(fileInput.files[0]);

      fReader.onloadend = function(event){
        oc.ajax('Checkout::onLoadFile', {
          data: { file: event.target.result, type: type, sessionKey: sessionKey }
        });
      }      
    });
  }
}